// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7022f036","533":"e63bf989","595":"d210a4fe","732":"d65a83c9","946":"a735ecdc"}[chunkId] + ".chunk.js";
};